import { NavLink, useLocation } from 'react-router-dom';
import { sections, isSectionActive } from '@/config/navigation';

export function SectionTabs() {
  const location = useLocation();

  return (
    <nav className="flex items-center gap-1">
      {sections.map((section) => {
        const isActive = isSectionActive(section, location.pathname);
        const Icon = section.icon;

        return (
          <NavLink
            key={section.id}
            to={section.subNav[0]?.path ?? section.basePath}
            className={`
              relative flex items-center gap-2 px-3 py-1.5 text-sm font-medium
              rounded-md transition-colors
              ${
                isActive
                  ? 'text-primary bg-primary/10'
                  : 'text-foreground-muted hover:text-foreground hover:bg-background-hover'
              }
            `}
          >
            <Icon className="h-4 w-4" />
            <span>{section.label}</span>
            {/* Active indicator */}
            {isActive && (
              <span className="absolute bottom-0 left-3 right-3 h-0.5 bg-primary rounded-full" />
            )}
          </NavLink>
        );
      })}
    </nav>
  );
}
